import { SellerFeedbackForm } from "../../components/seller/SellerFeedbackForm";
import { AuthHelper } from '../../utils/auth_helper';

import React from "react";
import Grid from '@mui/material/Grid';


function SellerFeedback() {

  return (
    <div>
      <div className="tw-px-5 tw-w-96 tw-inline-block tw-justify-center sm:tw-ml-20 tw-text-left">

          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-2xl"><p>Send Your Feedback / issue</p></span>
              </Grid>
            </Grid>

            <SellerFeedbackForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { SellerFeedback };
